import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function ChatAirplaneIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={19.95}
        height={20.1}
        fill="none"
        style={{
          maxHeight: 500,
        }}
        viewBox="0 5 19.95 20.1"
        {...props}
      >
        <g
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          clipPath="url(#ChatAirplaneIcon_svg__a)"
        >
          <path d="m7.537 17.383 3.525 7.303 8.293-19.121L.235 13.86zm0 0L19.355 5.565" />
        </g>
        <defs>
          <clipPath id="ChatAirplaneIcon_svg__a">
            <path
              fill="#fff"
              d="m13.946 0 10.975 10.975L11.058 24.84.083 13.864z"
            />
          </clipPath>
        </defs>
      </svg>
    </Icon>
  )
}
export default ChatAirplaneIcon
